<h3 style="text-align: center">Password successfully set</h3>
<p style="text-align: center">The new password has been set. You may now login.</p>

<div class="p-grid">
  <div class="p-col">
    <button pButton (click)="backToLogin()" label="Back to login" class="ui-button-secondary"></button>
  </div>
</div>
